<template>
    <router-link :to="{ name: 'home' }">
        <app-image url="logo.png" is-local alt="Pinguinitos logo"> </app-image>
    </router-link>
</template>

<script>
export default {
    name: "logo"
};
</script>
